import './Clients.css';
import '../Dashboard.css';
import Search from './Search/Search.js';
import Upload from './Upload/Upload.js';
import Documents from './Documents/Documents.js';
import Returns from './Returns/Returns.js';
import Questions from './Questions/Questions.js';
import { useMemo, useState } from 'react';

const VIEWS = [
    {
        id: 'search-clients',
        title: 'Search',
        component: Search,
    },
    {
        id: 'returns-clients-search',
        title: 'Returns',
        component: Returns,
    },
    {
        id: 'questions-clients-search',
        title: 'Questions',
        component: Questions,
    },
    {
        id: 'documents-clients-search',
        title: 'Documents',
        component: Documents,
    }
];
const DEFAULT_VIEW = VIEWS[0];

function Clients({ toggleNav }) {
    const [view, setView] = useState(DEFAULT_VIEW);
    const [currentClientID, setCurrentClientID] = useState(null);
    const [currentClientName, setCurrentClientName] = useState(null);
    const renderView = useMemo(() => {
        if (!view) return null;
        const View = view.component;
        return <View key={view.id} toggleNav={toggleNav} currentClientID={currentClientID} setCurrentClientID={setCurrentClientID} currentClientName={currentClientName} setCurrentClientName={setCurrentClientName} />
    }, [view, currentClientID, toggleNav, currentClientName]);

    return (
        <div className="Clients">
            {toggleNav && <div className="nav-container">
                {VIEWS.map((v) => (
                    <div key={v.id} className={`nav-link ${view.id === v.id ? 'active' : ''}`}
                        onClick={() => setView(v)}>
                        {v.title}
                    </div>
                ))}
            </div>}
            {renderView}
        </div>

    );
}

export default Clients;
